import React from 'react';
import { useAddQueryFnContext } from '@twiliointernal/org-twilio-platform-query-fn-context';

import { types } from './definitions';
import { APPLICATION_KEY } from '../../definitions/constants';

export const AppQueryFunctionsProvider = ({
  children,
}: types.AppQueryFunctionsProviderProps): React.ReactElement<types.AppQueryFunctionsProviderProps> => {
  useAddQueryFnContext(APPLICATION_KEY, {});

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
